import { Injectable } from '@angular/core';

export type MobileOS = 'android' | 'ios' | 'other';

@Injectable({ providedIn: 'root' })
export class OsDetectService {

  getMobileOS(): MobileOS {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') return 'other';

    const ua = navigator.userAgent ?? '';

    if (/Android/i.test(ua)) return 'android';

    if (/iPhone|iPad|iPod/i.test(ua)) return 'ios';

    const isIpadOs = /Macintosh/i.test(ua) && (navigator.maxTouchPoints ?? 0) > 1;
    if (isIpadOs) return 'ios';

    return 'other';
  }

  isAndroid(): boolean {
    return this.getMobileOS() === 'android';
  }

  isIOS(): boolean {
    return this.getMobileOS() === 'ios';
  }
}